const isLocal = process.env.REACT_APP_ENV?.toLowerCase() === "local";
export const base_url = isLocal
    ? (process.env.REACT_APP_API_URL_LOCAL || "http://localhost:5000/api/v1")
    : (process.env.REACT_APP_API_URL || "https://api.jugglerewards.app/api/v1/");
export const api_url = process.env.REACT_APP_API_URL || "https://api.jugglerewards.app/api/v1/";
